module.exports = wp.components;